import React, { Suspense, useMemo } from 'react'
import Single from './Components/Singles'
import Layout from './Components/Layout'
import NotFound from './Components/NotFound'
import HomePage from './Components/HomePage'
import Post from './Components/Post'
import Posts from './Components/Posts'
import Loader from './Components/Loader'
import useWpJson from './Hooks/useWpJson'
import useWpLogo from './Hooks/useWpLogo'
import state from './store'
import { useSnapshot } from 'valtio'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom'

import './index.css'

function App () {
  const snap = useSnapshot(state)
  const { sitedata, logodata } = useWpLogo()
  const menu = useWpJson('menu')
  const { page_on_front, show_on_front } = useWpJson('homepage-settings')
  useMemo(() => {
    state.menu = menu
    state.logo = logodata?.source_url
    state.site_name = sitedata?.name
    state.home_page_id = page_on_front
    state.home_page_type = show_on_front
  }, [menu, logodata, sitedata, page_on_front, show_on_front])

  useMemo(() => {
    if (
      snap?.menu &&
      // snap?.logo &&
      snap?.site_name &&
      snap?.home_page_id &&
      snap?.home_page_type
    ) {
      state.page_loaded = true
    }
  }, [snap])
  const router = useMemo(
    () =>
      createBrowserRouter(
        createRoutesFromElements(
          <>
            <Route
              path='/'
              loader={async () =>
                snap?.page_loaded &&
                (await fetch(
                  `/wp-json/wp/v2/pages?include=${snap?.home_page_id}&acf_format=standard`
                ))
              }
              action={async ({ request }) => {
                return await request.formData()
              }}
              element={
                <Layout>
                  <HomePage />
                </Layout>
              }
            />
            <Route
              path='/:page'
              loader={async () => {
                return await fetch('/wp-json/wp/v2/pages?acf_format=standard')
              }}
              action={async ({ request }) => {
                return await request.formData()
              }}
              element={
                <Layout>
                  <Single />
                </Layout>
              }
            />
            <Route
              path='/:postid/:postname'
              loader={async ({ params }) =>
                await fetch(
                  `/wp-json/wp/v2/posts?include=${params.postid}&acf_format=standard`
                )
              }
              action={async ({ request }) => {
                return await request.formData()
              }}
              element={
                <Layout>
                  <Post />
                </Layout>
              }
            />
            <Route
              path='/posts'
              loader={async ({ params }) =>
                await fetch(
                  `/wp-json/wp/v2/posts?&acf_format=standard`
                )
              }
              action={async ({ request }) => {
                return await request.formData()
              }}
              element={
                <Layout>
                  <Posts />
                </Layout>
              }
            />
            <Route
              path='404'
              errorElement={
                <Layout>
                  <NotFound />
                </Layout>
              }
            />
          </>
        )
      ),
    [snap]
  )
  return (
    <div className='App overflow-x-hidden'>
      <Suspense fallback={Loader}>
        {state.page_loaded ? <RouterProvider router={router} /> : <Loader />}
      </Suspense>
    </div>
  )
}

export default App
